import { request as sonataRequest } from 'sonata-react-components';

import type { CampaignPlanWithExtraData, PaginationResult } from 'sonata-static-storage/lib/common/common.types';

export async function getCampaignPlans(
  userId: string,
  params: URLSearchParams
): Promise<PaginationResult<CampaignPlanWithExtraData>> {
  return sonataRequest.makeRequest(`${taptap.config.backendUrlBase}multiflight/campaignPlan/${userId}`, {
    method: 'GET',
    params
  });
}
